module.exports = __webpack_public_path__ + "confidence.12jRkAOR.jpg";